<template>
  <section>
    <div class="card panel-white" v-if="displayConfirmBankTransferSection(order)">
      <div class="card-body">
        <label class="mb-0">{{ $t('message.confirm_order_payment.incomplete_payment') }}</label>

        <!-- CASE: Pending -->
        <template v-if="order.payment_data.method === 'pending'">
          <div class="mt-3">
            <span class="bullet-notification -status-pending">
              <i class="fas fa-circle"></i>
            </span>
            {{ $t('message.confirm_order_payment.provider_offer_booking') }}
          </div>
          <div class="pt-3">
            <button class="btn btn-info btn-block"
                   @click="clearTempData()">
              {{ $t('message.button.go_to_payment') }}
            </button>
          </div>
<!--          <div class="mt-4">-->
<!--            <h4 class="booking-title">{{ $t('message.booking.payment_step.promo_code') }}</h4>-->
<!--            <template v-if="order.promo_code_usage.applied">-->
<!--              <span class="summary-extras">-->
<!--                <i class="fas fa-check -status-accepted"></i>-->
<!--                {{ $t('message.booking.payment_step.applied_promo_code') }}: <label>{{ order.promo_code_usage.code }}</label> (-{{ order.promo_code_usage.discount }}%)-->
<!--              </span>-->
<!--            </template>-->
<!--            <template v-else>-->

<!--              <div class="card">-->
<!--                <div class="card-body p-3">-->
<!--                  <div class="d-flex" role="button" @click="openMyPromoCodeModal()">-->
<!--                    <div class="flex-fill">-->
<!--                      <i class="fal fa-ticket text-orange fa-lg"></i> {{ $t('message.booking.payment_step.promo_code') }}-->
<!--                    </div>-->
<!--                    <div class="flex-fill text-right text-black-50">-->
<!--                      {{ $t('message.booking.payment_step.select_promo_code') }} <i class="fal fa-angle-right"></i>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </template>-->
<!--          </div>-->
<!--          <div>-->
<!--            <div class="pt-4 pb-1">-->
<!--              <h4 class="booking-title">{{ $t('message.booking.checkout_step.payment_method') }}</h4>-->
<!--            </div>-->

<!--            <a href="" class="text-secondary" @click.prevent="openCreditCardPaymentModal(false)">-->
<!--              <div class="card">-->
<!--                <div class="card-body p-3">-->
<!--                  <i class="fal fa-credit-card"></i> {{ $t('message.payment_method.credit_debit_card') }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </a>-->

<!--            <a href="" class="text-secondary" @click.prevent="openConfirmBankTransferModal()">-->
<!--              <div class="card">-->
<!--                <div class="card-body p-3">-->
<!--                  <i class="fal fa-money-bill-wave"></i> {{ $t('message.payment_method.bank_transfer') }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </a>-->

<!--            <router-link :to="`/orders/${order.id}/confirm-promptpay`">-->
<!--              <div class="card">-->
<!--                <div class="card-body px-3 py-2 text-dark">-->
<!--                  <i class="fal fa-qrcode"></i> {{ $t('message.payment_method.promptpay') }}-->
<!--                  <img src="/static/img/thai_qr_payment.png" height="40" class="rounded ml-2"/>-->
<!--                </div>-->
<!--              </div>-->
<!--            </router-link>-->
<!--          </div>-->
        </template>

        <!-- CASE: Bank Transfer -->
        <template v-else-if="order.payment_data.method === 'bank_transfer' || order.payment_data.method === 'promptpay'">
          <template v-if="globalState">
            <p v-html="$options.filters.bankTransferDurationText(order, globalState)"></p>
          </template>
          <div class="mt-3" v-if="!order.is_reviewed">
            <router-link :to="`/orders/${order.id}/confirm-promptpay`" class="btn btn-info btn-block"
                    v-if="order.payment_data.method === 'promptpay'"
                    @click="openConfirmBankTransferModal()">
              {{ $t('message.button.go_to_payment') }}
            </router-link>

            <button class="btn btn-info btn-block"
                    v-if="order.payment_data.method === 'bank_transfer'"
                    @click="openConfirmBankTransferModal()">
              {{ $t('message.button.confirm_bank_transfer') }}
            </button>
          </div>
        </template>

        <!-- CASE: Credit Card -->
        <template v-else-if="order.payment_data.method === 'credit_card' && order.order_payment_failure && !order.is_reviewed">
          <div class="mt-3">
                <span class="bullet-notification -status-pending">
                  <i class="fas fa-circle"></i>
                </span>
            {{ $t('message.alert.payment_error_cannot_charge', { msg: order.order_payment_failure.failure_message }) }}
          </div>
          <div class="mt-3">
            <router-link class="btn btn-info btn-block"
              :to="`/reservation/${order.id}/confirm-professional-booking`">
              {{ $t('message.button.change_payment_method') }}
            </router-link>
<!--            <div class="row no-gutters">-->
<!--              <div class="col-6 pr-2">-->
<!--                <button class="btn btn-outline-info btn-block"-->
<!--                        v-if="!order.is_reviewed"-->
<!--                        @click="openConfirmBankTransferModal()">-->
<!--                  {{ $t('message.button.bank_transfer') }}-->
<!--                </button>-->
<!--              </div>-->
<!--              <div class="col-6 pl-2">-->
<!--                <button class="btn btn-info btn-block"-->
<!--                        v-if="!order.is_reviewed"-->
<!--                        @click="openCreditCardPaymentModal(true)">-->
<!--                  {{ $t('message.button.change_new_card') }}-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div v-if="order.order_payment_failure && order.order_payment_failure.failure_code === 'insufficient_fund'">
            <div class="mt-4">
                <span class="bullet-notification -status-pending">
                  <i class="fas fa-circle"></i>
                </span>
              {{ $t('message.alert.insufficient_fund_remark') }}
            </div>
            <div class="mt-3">
              <button class="btn btn-outline-info btn-block"
                      @click="openConfirmCreditCardLimitDialog()">
                {{ $t('message.button.confirm_credit_limit') }}
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- Confirm Bank Transfer Modal -->
    <confirm-bank-transfer-modal ref="confirmBankTransferModal"/>

    <!-- Confirm Credit Card Payment Modal -->
    <confirm-credit-card-payment-modal ref="confirmCreditCardPaymentModal" :order="order"/>

    <!-- My Promo Code modal -->
    <my-promo-code-modal ref="myPromoCodeModal"
                         :searchParams="searchParams"
                         @onSelected="selectPromoCode"></my-promo-code-modal>
  </section>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import ConfirmBankTransferModal from './ConfirmBankTransferModal'
  import ConfirmCreditCardPaymentModal from './CreditCardPaymentModal'
  import MyPromoCodeModal from '../../booking/components/MyPromoCodeModal'

  export default {
    props: ['order'],
    components: {
      ConfirmBankTransferModal,
      ConfirmCreditCardPaymentModal,
      MyPromoCodeModal
    },
    data () {
      return {
        searchParams: null
      }
    },
    computed: {
      ...mapState('auth', ['isLineLoggedIn']),
      ...mapGetters({
        globalState: 'globalVal/getState',
        appliedPromoCode: 'promoCode/getAppliedPromoCode',
        isApplying: 'promoCode/isApplying',
        state: 'promoCode/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      async isApplying () {
        if (!this.state.isApplying) {
          await this.loadOrderDetail(this.order.id)
        }
      }
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      clearTempData () {
        this.$store.commit('booking/SET_TMP_BOOKING_DATA', null)
        this.$store.commit('booking/SET_TMP_PRE_CHECKOUT_DATA', null)
        this.$store.commit('booking/SET_PRE_CHECKOUT_DATA', null)
        this.$store.commit('promoCode/SET_APPLIED_PROMO_CODE', null)
        this.$router.push(`/reservation/${this.order.id}/confirm-professional-booking`)
      },
      openMyPromoCodeModal () {
        this.$refs.myPromoCodeModal.showMyPromoCodeModal(true)
      },
      openConfirmCreditCardLimitDialog () {
        this.$swal({
          text: this.$i18n.t('message.alert.confirm_credit_card_limit'),
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.button.confirm'),
          cancelButtonText: this.$i18n.t('message.button.cancel')
        }).then((result) => {
          if (result) {
            this.$store.dispatch('orderDetail/CONFIRM_CREDIT_CARD_LIMIT', this.order.id)
          }
        })
      },
      displayConfirmBankTransferSection (order) {
        let result = false
        if (order.cancel === 0) {
          switch (order.payment_data.method) {
            case 'credit_card':
            case 'promptpay':
              if (order.paid_status === 0) {
                result = true
              }
              break
            case 'pending':
              result = true
              break
            case 'bank_transfer':
              if (order.paid_status === 0 && !order.is_expired_bank_transfer && order.bank_transfer_data === null) {
                result = true
              }
              break
          }
        }
        return result
      },
      openConfirmBankTransferModal () {
        this.$refs.confirmBankTransferModal.showConfirmBankTransferModal(true)
      },
      openCreditCardPaymentModal (isChangingNewCard) {
        this.$refs.confirmCreditCardPaymentModal.showCreditCardPaymentModal(true)
        this.$refs.confirmCreditCardPaymentModal.setChangingNewCard(isChangingNewCard)
      },
      selectPromoCode (promoCode) {
        if (promoCode && this.user && this.order) {
          const submitData = {
            user_id: this.user.id,
            promo_code: promoCode.code,
            province_id: this.order.province_id,
            service_id: this.order.service_id,
            work_hour: this.order.work_hour,
            order_id: this.order.id
          }
          this.$store.dispatch('promoCode/APPLY_PROMO_CODE', submitData)
        }
      }
    },
    mounted () {
      // Set searchParams for searching promo code
      this.searchParams = {
        province_id: this.order.province_id,
        service_id: this.order.service_id,
        work_hour: this.order.work_hour
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ConfirmOrderPaymentSection.vue